module.exports = __webpack_public_path__ + "static/media/ruspolymet.ab25ffbb.png";